export const FilterTypeConstants = {
    GET_FILTERTYPE: 'GET_FILTERTYPE',
    SET_FILTERTYPE: 'SET_FILTERTYPE'
};